module.exports = __webpack_public_path__ + "static/media/icon_message.c68b57df.svg";